// entry point for integration loader helper script
// -> loads the main integration and or iframe scripts depending on detected elements
((window: Window, document: Document) => {
  const scriptId = 'nc-sdk-loader';
  const elementClassName = 'nc-sdk';

  const createHeadScript = (id: string, src: string) => {
    const existing = document.getElementById(id);
    if (existing) {
      console.log(
        `[NC-SDK-Loader] Script with ID ${id} already exists, replacing (src: ${(existing as HTMLScriptElement).src})`
      );
      existing.remove();
      if ('src' in existing && typeof existing.src === 'string') {
        const existingUrl = new URL(existing.src);
        const versionParam = existingUrl.searchParams.get('v');
        let newVersion = (versionParam && parseInt(versionParam)) || 0;
        newVersion++;
        const newUrl = new URL(src);
        newUrl.searchParams.set('v', newVersion.toString());
        src = newUrl.toString();
      }
    }
    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.type = 'module';
    document.head.appendChild(script);
    console.log(`[NC-SDK-Loader] Script with ID ${id} added to head (src: ${src})`);
  };

  const createHeadStyles = (id: string, styles: string) => {
    const existing = document.getElementById(id);
    if (existing) {
      console.log(`[NC-SDK-Loader] Styles with ID ${id} already exist, replacing`);
      existing.remove();
    }
    const style = document.createElement('style');
    style.id = id;
    style.innerHTML = styles;
    document.head.appendChild(style);
    console.log(`[NC-SDK-Loader] Styles with ID ${id} added to head`);
  };

  const handleLoad = () => {
    console.log('[NC-SDK-Loader] Loading...');
    const loaderScript = document.getElementById(scriptId) as HTMLScriptElement;
    if (!loaderScript) {
      console.warn(`[NC-SDK-Loader] Loader script with ID ${scriptId} not found`);
      return;
    }
    const loaderScriptUrl = new URL(loaderScript.src);
    const baseUrl = loaderScriptUrl.origin;

    const sdkElements = document.getElementsByClassName(elementClassName);

    let hasIframe = false;
    let hasIntegration = false;

    for (const element of sdkElements) {
      const htmlElement = element as HTMLElement;
      const dataset = htmlElement.dataset;
      if (dataset.type === 'iframe') {
        hasIframe = true;

        const params = new URLSearchParams();
        const applyParam = (key: string) => {
          if (dataset[key]) {
            params.set(key, dataset[key]);
          }
        };
        applyParam('component');
        applyParam('platform');
        applyParam('accountId');
        applyParam('filter');
        applyParam('theme');
        applyParam('recaptcha');

        const iframe = document.createElement('iframe');
        iframe.classList.add('nc-sdk-iframe');
        iframe.src = `${baseUrl}/${dataset.language || 'de'}/sdk/?${params.toString()}`;
        iframe.title = 'NC SDK Integration';

        Object.getOwnPropertyNames(dataset)
          .filter((key) => key.startsWith('attribute'))
          .forEach((key) => {
            const attribute = key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
            iframe.setAttribute(attribute.replace('attribute-', ''), dataset[key] || '');
          });

        element.innerHTML = '';
        element.appendChild(iframe);
      } else {
        hasIntegration = true;
      }
    }

    if (hasIframe) {
      console.log('[NC-SDK-Loader] Loading iframe integration');
      createHeadScript('nc-sdk-iframe-script', `${baseUrl}/scripts/sdk/iframe.js`);
      createHeadStyles(
        'nc-sdk-iframe-styles',
        `.nc-sdk-iframe {
          width: 100%;
          height: 100%;
          border: none;
        }`
      );
    }

    if (hasIntegration) {
      console.log('[NC-SDK-Loader] Loading direct integration');
      createHeadScript('nc-sdk-polyfills-script', `${baseUrl}/scripts/sdk/polyfills.js`);
      createHeadScript('nc-sdk-main-script', `${baseUrl}/scripts/sdk/index.js`);
    }
  };

  // console.log(document.readyState);
  if (document.readyState === 'loading') {
    window.addEventListener('load', handleLoad);
  } else {
    handleLoad();
  }
})(window, window.document);
